import FallbackVisitor from "../../FallbackVisitor.mjs";
const RequestBodyVisitor = FallbackVisitor;
export default RequestBodyVisitor;